<template>
  <div class="count-index">
    <div class="refresh-box">
      <strong style="margin-right: 10px">学期数据统计</strong>
      <Button
        type="primary"
        shape="circle"
        icon="md-refresh"
        :loading="showSpin"
        style="margin-right: 10px"
        @click="getEduBillStatisticsForEdu(null, 1)"
      ></Button>
      <span>截止：{{ date }}</span>
    </div>
    <ul class="count-list">
      <Spin v-show="showSpin" fix></Spin>
      <li>
        <span class="font-bold" style="color: #2db7f5">{{ totalPayment }}</span>
        <p>收款总额</p>
      </li>
      <li>
        <span class="font-bold" style="color: #63a103">{{ refundAmount }}</span>
        <p>退款总额</p>
      </li>
      <li>
        <span class="font-bold">{{ canBeSettlementAmount }}</span>
        <p>可结算金额</p>
      </li>
      <li>
        <span class="font-bold" style="color: #d9001b">{{ finishAmount }}</span>
        <p>已结算金额</p>
      </li>
      <li>
        <span class="font-bold" style="color: #d9001b">{{
          inSettlementAmount
        }}</span>
        <p>结算中金额</p>
      </li>
      <li>
        <span class="font-bold" style="color: #d9001b">{{ awaitAmount }}</span>
        <p>待结算金额</p>
      </li>
      <li>
        <span class="font-bold" style="color: #d9001b">{{
          noSettlementAmount
        }}</span>
        <p>不可结算金额</p>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import orderCenterApi from '@/request/orderCenter/index.js';
import { abs } from '@/utils/utils.js';
export default {
  data() {
    return {
      totalPayment: 0.00,
      canBeSettlementAmount: 0.00,
      finishAmount: 0.00,
      inSettlementAmount: 0.00,
      awaitAmount: 0.00,
      refundAmount: 0.00,
      showSpin: false,
      noSettlementAmount: 0.00,
      searchData: null,
      date: '',
      staticData: {
        'totalPayment': '7412000000',
        'canBeSettlementAmount': '7198000000',
        'finishAmount': '3132450900',
        'awaitAmount': '4065549100',
        'refundAmount': '214000000',
        'noSettlementAmount': '0',
        'inSettlementAmount': '0',
        'date': '2023-11-03 14:10:36'
      }
    };
  },
  computed: {
    ...mapState(['userInfo'])
  },
  created() {

  },
  methods: {
    init() {

    },
    async getEduBillStatisticsForEdu(data, refresh = 0) {
      this.showSpin = true;
      data ? this.searchData = data : '';
      const res = await orderCenterApi.getEduBillStatisticsForEdu({ ...this.searchData, refresh });
      this.showSpin = false;
      if (res.status == 200 && this.userInfo.orgId === '614867004922269697') {
        for (const k in this.staticData) {
          this[k] = k != 'date' ? abs(this.staticData[k]) : this.staticData[k];
        }
      } else if (res.status == 200) {
        for (const k in res.message) {
          this[k] = k != 'date' ? abs(res.message[k]) : res.message[k];
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.count-index {
  margin-bottom: 22px;
  position: relative;
  background: #eff0f8;
  overflow: hidden;
  padding: 10px 0;
  border-radius: 4px;
}
.count-list {
  display: flex;
  justify-content: space-around;

  li {
    width: 180px;
    height: 80px;
    text-align: center;
    box-sizing: border-box;
    padding-top: 16px;
    border-radius: 10px;
    background: #fff;
    margin: 0 8px;

    // background: #EFF0F8;

    p {
      padding-top: 10px;
    }
  }
  // li+li{
  //   margin-right: left;
  // }
}
.refresh-box {
  padding-left: 12px;
  margin-bottom: 24px;
  margin-right: 16px;
  strong {
  }
  span {
    font-size: 14px;
    color: #666;
  }
}
</style>
